import './BaseNodeCard.css';
import { cardTitle } from '../../assets/jss/wisene-material-dashboard-pro-react-types';
import { ClassNameMap } from '@material-ui/styles';
import { closeSweetAlertStyle } from '../../helpers/CustomStyles';
import { connect } from 'react-redux';
import { baseAndWaitForRecalc } from '../../stores/actions/nodeActions';
import Button from '../../../components/CustomButtons/ButtonTS';
import CancelIcon from '@material-ui/icons/Cancel';
import Card from '../../../components/Card/CardTS';
import CardHeader from '../../../components/Card/CardHeaderTS';
import CardIcon from '../../../components/Card/CardIcon.js';
import dashboardStyle from '../../assets/jss/views/dashboardStyleTS';
import Download from '@material-ui/icons/CloudDownload';
import ErrorComponent from '../ErrorComponent/ErrorComponent';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import React from 'react';
import styles from '../../assets/jss/views/dashboardStyle';
import { SYSTEM_VERSIONS } from '../../helpers/Systems';
import BaseNodeCardBody from './BaseNodeCardBody';


const style = {
	cardTitle,
	cardCategory: styles.cardCategory,
};


interface IBaseNodeCardProps {
	changed?: Date;
	baseAngle: number;
	baseDistance: number;
	classes: ClassNameMap;
	hideAlert: () => void;
	mainSensorType: string;
	nodeID: number;
	nodeName: string;
	systemVersion: string;
	updatedViaWebsiteAt: string;
	isEditing: boolean;
	systemID: number;
	measuredAngle: number;
	measuredDistance: number;
}
interface IBaseNodeCardState {
	baseAngle: number;
	baseDistance: number;
	lock: boolean;
	mainSensorType: string;
	measuredAngle: number;
	measuredDistance: number;
	measurementTimestamp: number;
	nodeID: number;
	nodeName: string;
	systemVersion: string;
	loading: boolean;
}

class BaseNodeCard extends React.Component<IBaseNodeCardProps, IBaseNodeCardState> {
	state: IBaseNodeCardState = {
		baseAngle: this.props.baseAngle,
		baseDistance: this.props.baseDistance,
		loading: false,
		lock: false,
		mainSensorType: this.props.mainSensorType,
		measuredAngle: this.props.measuredAngle,
		measuredDistance: this.props.measuredDistance,
		measurementTimestamp: null,
		nodeID: this.props.nodeID,
		nodeName: this.props.nodeName,
		systemVersion: '',
	};

	base = (nodeID: number, newBase: number, updatedViaWebsiteAt: string) => {
		this.props.base(nodeID, newBase, updatedViaWebsiteAt)
		this.props.hideAlert();
	};

	handleCurrentValueChange = (newVal) => {
		if (this.state.measuredDistance) {
			this.setState({ baseDistance: newVal });
		}

		if (this.state.measuredAngle) {
			this.setState({ baseAngle: newVal });
		}
	}

	render() {
		const { systemVersion, nodeName } = this.state;

		// Prevent showing window for W2
		if (systemVersion === SYSTEM_VERSIONS.W2) {
			return <p>Option not available for W2 system version.</p>
		}

		return (
			<ErrorComponent Children message='Something was wrong'>
				<GridContainer>
					<GridItem xs={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
						<Button
							simple
							justIcon
							color='info'
							style={closeSweetAlertStyle}
							onClick={this.props.hideAlert}
							data-testid='cancelButton'
						>
							<CancelIcon style={{ width: '20px', height: '20px' }} />
						</Button>
					</GridItem>
				</GridContainer>

				<Card chart style={{ overflow: 'visible', marginTop: '10px', marginBottom: '0' }} data-testid='exportCard'>

					<CardHeader color='info' icon>
						<CardIcon color='info'>
							<Download />
						</CardIcon>
						<p style={{ ...style.cardCategory, textAlign: 'left' }}>Set base:</p>
						<h3 style={{ ...style.cardTitle, textAlign: 'left' }}>{nodeName}</h3>
					</CardHeader>

					<BaseNodeCardBody
						baseAndWaitForRecalc={this.props.baseAndWaitForRecalc}
						baseAngle={this.state.baseAngle}
						baseDistance={this.state.baseDistance}
						lastMeasurementTimestamp={this.state.measurementTimestamp}
						mainSensorType={this.state.mainSensorType}
						nodeID={this.state.nodeID}
						nodeName={this.state.nodeName}
						updatedViaWebsiteAt={this.props.updatedViaWebsiteAt}
						isEditing={this.props.isEditing}
						systemID={this.props.systemID}
						hideAlert={this.props.hideAlert}
						measuredAngle={this.state.measuredAngle}
						measuredDistance={this.state.measuredDistance}
					/>
				</Card>
			</ErrorComponent>
		);
	}
}

const actions = { baseAndWaitForRecalc };

export const ExportCardWithStyles = dashboardStyle(BaseNodeCard);
export default connect(null, actions)(ExportCardWithStyles);
